// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2VWbH","icon":"SortAdornment_icon__3riJr","up":"SortAdornment_up__1cDUA","down":"SortAdornment_down__39ksR","active":"SortAdornment_active__1_a7J"};